import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5815e02e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "serviceEvaluation",
  class: "service-evaluation-container"
}
const _hoisted_2 = {
  ref: "contentWrapper",
  class: "content-wrapper"
}
const _hoisted_3 = { class: "line-info" }
const _hoisted_4 = { class: "line-route-name" }
const _hoisted_5 = { class: "campus-name" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1 /* HOISTED */))
const _hoisted_7 = { class: "rating-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "question" }, [
  /*#__PURE__*/_createTextVNode(" 해피로드와 함께한 출퇴근길,"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 만족스러우셨나요? ")
], -1 /* HOISTED */))
const _hoisted_9 = { class: "stars" }
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = {
  key: 0,
  class: "rating-value"
}
const _hoisted_12 = {
  key: 1,
  class: "info-text"
}
const _hoisted_13 = {
  key: 0,
  class: "divider"
}
const _hoisted_14 = {
  key: 1,
  class: "feedback-section"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "question",
  for: "opinion"
}, " 자유롭게 의견을 남겨주세요 ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: "서비스 평가" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode($setup["LineTypeChip"], {
              lineTypeCode: $setup.lineTypeCode,
              lineTypeName: $setup.lineTypeName
            }, null, 8 /* PROPS */, ["lineTypeCode", "lineTypeName"]),
            _createElementVNode("p", _hoisted_4, _toDisplayString($setup.lineName), 1 /* TEXT */),
            _createElementVNode("p", _hoisted_5, _toDisplayString($setup.campusName), 1 /* TEXT */)
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (rating) => {
                return _createElementVNode("button", {
                  key: rating,
                  class: "star-btn",
                  type: "button",
                  "aria-label": `${rating}점 선택`
                }, [
                  _createVNode($setup["InlineSvg"], {
                    src: 
                  $setup.selectedRating >= rating
                    ? require('@/assets/icons/star-fill.svg')
                    : require('@/assets/icons/star-empty.svg')
                ,
                    class: _normalizeClass(["star-icon", { selected: $setup.selectedRating >= rating }]),
                    onClick: ($event: any) => ($setup.handleRatingSelect(rating))
                  }, null, 8 /* PROPS */, ["src", "class", "onClick"])
                ], 8 /* PROPS */, _hoisted_10)
              }), 64 /* STABLE_FRAGMENT */)),
              ($setup.selectedRating)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                    _createElementVNode("strong", null, _toDisplayString($setup.selectedRating) + "점", 1 /* TEXT */),
                    _createTextVNode("(" + _toDisplayString($setup.ratingDescription) + ") ", 1 /* TEXT */)
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_12, "선택하세요"))
            ])
          ]),
          _createCommentVNode(" 별점이 1일 때만 텍스트 입력 영역 표시 "),
          ($setup.selectedRating === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13))
            : _createCommentVNode("v-if", true),
          ($setup.selectedRating === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _createVNode($setup["BaseTextarea"], {
                  class: "text-area-container",
                  id: "opinion",
                  cols: 30,
                  rows: 6,
                  maxlength: 300,
                  value: $setup.feedbackText,
                  placeholder: "여러분의 의견이 더 나은 서비스를 만듭니다. 자유롭게 의견을 남겨주세요!",
                  getTextAreaLength: $setup.feedbackText.length,
                  onOnInput: $setup.onInputTextarea
                }, null, 8 /* PROPS */, ["value", "getTextAreaLength"])
              ]))
            : _createCommentVNode("v-if", true)
        ], 512 /* NEED_PATCH */),
        _createVNode($setup["FooterButton"], {
          class: "base-button",
          title: "평가완료",
          disabled: !$setup.isEvaluable,
          onOnClickFooterButton: $setup.onClickEvaluate
        }, null, 8 /* PROPS */, ["disabled"])
      ], 512 /* NEED_PATCH */),
      ($setup.contentWrapper)
        ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
            key: 0,
            class: "scroll-top-wrapper",
            container: $setup.contentWrapper
          }, null, 8 /* PROPS */, ["container"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}